<template>
<div style="background-color: #ffffffd9">
    <div class="backgimg"></div>
	<div class="container">
    <div class="row">
      <div class="col-12 col-md-2 mb-4 mb-md-0 py-4" data-aos="fade-up">
        <div
          class="sidebar d-flex flex-column theme-border-radius theme-bg-white theme-box-shadow sticky"
        >
          <a
            href="/about-us"
            class="border-bottom p-3 theme-text-accent-one"
            >About us</a
          ><a href="/contact-us" class="border-bottom p-3 theme-text-accent-one"
            >Contact us</a
          ><a href="/privacy-policy" class="border-bottom p-3 theme-text-accent-one"
            >Privacy Policy</a
          >
          <a href="/terms-conditions" class="border-bottom p-3 theme-text-accent-one"
            >Terms of use</a
          >
        </div>
      </div>
      <div
        class="col-12 col-md-10 privacyContent py-4"
        v-html="privacyContent"
      ></div>
    </div>
	</div>
  </div>
</template>



<script>

import axios from "axios";

import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

export default {
    data() {
        return {

            privacyContent:"",
            getPrivacyUrl: "",
            privacyType: "",
            getLangname:"",
        }
    },

    methods: {

        getConfig() {
            // let getConfigData = this.$store.state.data

            // let portalLocal = localStorage.getItem("portalData")
            // let getConfigData = JSON.parse(portalLocal)
            const getConfigData = getConfigDataFromLocalStorage();
            if (getConfigData) {
                 let locale = this.getLangname;
                let getsiteContentData = getConfigData.payload.portal_configuration.site_content_data[locale]
                console.log(getsiteContentData,getsiteContentData?.privacypolicy, 'head...about..1..')
                if(getsiteContentData && getsiteContentData?.privacypolicy){
                  this.getPrivacyUrl = getsiteContentData.privacypolicy.url
                  this.privacyType = getsiteContentData.privacypolicy.type
                // console.log(this.getPrivacyUrl, 'head...about..2..')

                  this.getConfigFunc();
                }
            }
        },

        getConfigFunc() {
            axios.get(this.getPrivacyUrl, {
                headers: {
                    "Content-Type": this.privacyType,
                },
            })
                .then((response) => {
                    const cleanedResponse = response.data.replace(/text-center/g, "");
                    this.privacyContent = cleanedResponse
                    // console.log(response.data, "getPrivacyUrlrgetPrivacyUrlrgetPrivacyUrlrab.....")

                })

                .catch((error) => {
                    console.log(error, 'erroroor.....')
                })
        },
        updateContent() {
            this.getLangname = this.$i18n.locale;
            console.log(this.$i18n.locale, 'getcontententUrl...1')
            this.getConfig();
        }
    },
     watch:{
        "$i18n.locale": {
			handler: function () {
				this.updateContent();
				// this.getConfig();
				// this.getConfigFunc();
			},
			deep: true,
		},
    },

    created() {
            this.updateContent();
            // this.getConfig();
            // this.getConfigFunc();
    }
}

</script>
<style scoped>
@media screen and (max-width:480px) {
  :deep(.footr-content-wrap p){
    text-align:justify;
  }
}
:deep(.privacyContent){
    text-align:justify;
}
:deep(.privacyContent ul){
    list-style:disc !important;
    padding-left:2rem !important;
    margin:10px 0px;
}
:deep(.privacyContent h4){
    font-size:22px !important;
}
:deep(.privacyContent h2){
    font-size:30px !important;
    margin-top:0px !important;
}
:deep(.privacyContent h3){
    font-size:24px !important;
    margin-top:25px !important;
}
:deep(.privacyContent p){
  margin-bottom:1rem !important;
  margin-top:1rem !important;
}
:deep(.privacyContent a:focus){
	color:#0d6efd !important;
}
.sticky {
    position: sticky;
    top: 15%;
    background-color: #fff !important;
}
.theme-box-shadow {
    box-shadow: 0 0 .8rem rgba(52, 53, 52, .15);
}
.theme-border-radius, .theme-border-radius-top {
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
}
.border-bottom {
    border-bottom: 1px solid #dee2e6 !important;
}
.theme-text-accent-one {
    color: #343534;
}
a{
	text-decoration:none;
}
.backgimg{
  /* background-image: url(https://www.columbiathreadneedle.com/uploads/2022/07/7261494b4139321e43bea28c6616b256/jumbo-jet-taking-off.jpg); */
  background-image: url(../assets/images/footer-3.jpg);

  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 400px;
  width: 100%;
}
</style>